import { z } from "zod";

export const CURRENT_PROTOCOL_VERSION = 3;

export const IsoTimestampSchema = z.string().datetime({ offset: true });

export const SessionKeySchema = z
  .string()
  .min(1)
  .max(200)
  .regex(/^[A-Za-z0-9._@-]+(?:\/[A-Za-z0-9._@-]+)*$/, "Invalid session key");

export const IdentifierSchema = z
  .string()
  .min(1)
  .max(96)
  .regex(/^[A-Za-z][A-Za-z0-9._/-]*$/, "Invalid identifier");

export const PositionSelectorSchema = z.enum(["@root", "@tip"]);
export const PositionRefSchema = z.union([IdentifierSchema, PositionSelectorSchema]);

export const AtomIdSchema = IdentifierSchema;
export const CellIdSchema = IdentifierSchema;
export const PositionIdSchema = IdentifierSchema;

export const AliasKeySchema = z
  .string()
  .min(1)
  .max(48)
  .regex(/^\$?[A-Za-z][A-Za-z0-9_]*$/, "Invalid alias key");

export const RelativePathSchema = z
  .string()
  .min(1)
  .refine((value) => !value.startsWith("/"), "Expected a relative path");

export const RuntimeNameSchema = z.enum(["bun", "deno", "node", "unknown"]);

export const BoardProfileSchema = z.enum(["universal"]);
export type BoardProfile = z.infer<typeof BoardProfileSchema>;

export type JsonPrimitive = boolean | null | number | string;
export type JsonValue = JsonObject | JsonPrimitive | JsonValue[];
export type JsonObject = { [key: string]: JsonValue };

export const JsonValueSchema: z.ZodType<JsonValue> = z.lazy(() =>
  z.union([
    z.null(),
    z.boolean(),
    z.number(),
    z.string(),
    z.array(JsonValueSchema),
    z.record(z.string(), JsonValueSchema),
  ]),
);

export const JsonObjectSchema: z.ZodType<JsonObject> = z.record(
  z.string(),
  JsonValueSchema,
);
